import { baseApi, Tag } from './base'
import { Document } from '../models/document.model'
import { Establishment, UpdateEstablishmentDto } from '../models/establishment.model'
import { cacheByIdArg } from '@/utils/rtkQueryCacheUtils'

export const establishmentApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getEstablishment: builder.query<Establishment, string>({
      query: (establishmentId) => `/establishments/${establishmentId}`,
      providesTags: cacheByIdArg(Tag.ESTABLISHMENT),
    }),
    getEstablishmentBackgrounds: builder.query<Document[], { establishmentId: string; key?: string }>({
      query: ({ establishmentId, key }) => ({
        url: `/establishments/${establishmentId}/backgrounds`,
        method: 'GET',
        params: key ? { key } : undefined,
      }),
      providesTags: (result, error, arg) => [{ type: Tag.ESTABLISHMENT, id: arg.establishmentId }],
    }),
    updateEstablishment: builder.mutation<Establishment, { id: string; data: UpdateEstablishmentDto }>({
      query: ({ id, data }) => ({
        url: `/establishments/${id}`,
        method: 'PATCH',
        body: data,
      }),
    }),

  }),
  overrideExisting: false,
})
